import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { routes } from '../../utils/constants';
import PrimaryBtn from '../ReactComponent/PrimaryButton';
import SecondaryBtn from '../ReactComponent/SecondaryButton';
import Column from '../ReactComponent/Column';
import Row from '../ReactComponent/Row';
import { H2 } from '../../theme/typography';
import { PageDescription } from './css';
import { homeUrlNoTrailingSlash } from '../../utils/func';

const RenderHeader = ({ heading, description, handleDownloadReport }) => {
  const handleCreateShipment = (e) => {
    e.preventDefault();
    const createShipmentUrl = `${homeUrlNoTrailingSlash()}${routes.createShipment}`;
    window.location.href = createShipmentUrl;
  };

  return (
    <Row style={{ margin: '45px 0' }}>
      <Column $tablet={8} $mobile={12} style={{ padding: '0px' }}>
        <div>
          <H2>{heading}</H2>
          <PageDescription>{description}</PageDescription>
        </div>
      </Column>
      <Column $tablet={4} $mobile={12} style={{ textAlign: 'end', padding: '0px' }}>
        <PrimaryBtn className="active" iconRightArrow style={{ margin: '16px 0' }} onClick={(e) => handleCreateShipment(e)}>
          {t('CreateAShipment')}
        </PrimaryBtn>
        <SecondaryBtn className="active" iconRightArrow onClick={() => handleDownloadReport()}>
          {t('DownloadReport')}
        </SecondaryBtn>
      </Column>
    </Row>
  );
};

RenderHeader.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  handleDownloadReport: PropTypes.func,
};

export default RenderHeader;
